export default __webpack_public_path__ + "static/media/friends.4e8271e8.jpg";